import(/* webpackMode: "eager", webpackExports: ["RestaurantDetails"] */ "/vercel/path0/src/components/restaurants/restaurant-details.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RestaurantSidebarLeft"] */ "/vercel/path0/src/components/sidebars/restaurant-sidebar-left.tsx");
